import { Component } from '@angular/core';
import { DataLayerBaseComponent } from './data-layer-base.component';
import { DataLayerGeojsonPointComponent } from './data-layer-geojson-point.component';
import { MapService } from './map.service';
import { DataLayerService } from './data-layer.service';
import { ConfigService } from './config.service';
import { AppConfigService } from './app-config.service';
import { UserMessageService } from './user-message.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AdminWebServicesService } from './admin-web-services.service';
import { CookieService } from 'ngx-cookie';

declare var L;

/*
 * data-layer-geojson-cameras defines a class to display cameras.  The data format is geojson.
 *
 * Example of the data file:
 * --------------------------------
 * {
 *	"type": "FeatureCollection",
 *	"features": [
 *	  {
 *		"type": "Feature",
 *		"properties": {
 *			"data_source": "WETMap",
 *			"name": "WET Office",
 *			"link": "http://www.wunderground.com/webcams/WETInc/2/show.html",
 *			"image": "http://cameraftpapi.drivehq.com/api/Camera/GetCameraThumbnail.ashx?parentID=237442473&shareID=13862329",
 *			"image_height": 360,
 *			"image_width": 640
 *		},
 *		"geometry": {
 *		  "type": "Point",
 *		  "coordinates": [-105.07477, 40.603510]
 *		}
 *	  },
 *	  ...
 *	]
 * }
 * --------------------------------
 *
 * Within the configuration file, camera stations can be included:
 * "overlayLayers": [
 * 		{"id": "cameraLayer", "label": "Cameras", "url": "map/overlay-layers/cameraStations.geojson",
 *		 "class": "data-layer-cameras", "refresh": true },
 * ...
 * ]
 */

@Component({
	selector: 'data-layer-cameras-blueiris',
	standalone: false,
	template: `
		<div class="checkboxDiv"><label class="overlay-layer"><input type="checkbox" (click)="menuControlSelected($event)">{{htmlElementLabel}}</label>
		<app-single-legend [active]=active [legendUrl]=legendUrl></app-single-legend>
		</div>

		`,
	styleUrls: ['app.component.css']
})
export class DataLayerGeojsonCamerasBlueIrisComponent extends DataLayerGeojsonPointComponent {

	http;
	sessionID: string = "";
	activelyLoggedIn = false;
	timeoutId: any = null;

	constructor (
		mapService: MapService,
		dataLayerService: DataLayerService,
		configService: ConfigService,
		private adminWS: AdminWebServicesService,
		http: HttpClient, 
		private cookieService: CookieService,
		private appConfigService: AppConfigService,

		userMessageService: UserMessageService ) {

		super (mapService, dataLayerService, configService, userMessageService );
		this.htmlElementLabel = 'Cameras (Blue Iris)';
		this.http = http;
	}

	// When activating the blue iris layer, 
	// log into the server,
	// activate layers as otherwise
	// and set a timer to relogin every 60 seconds since that is how long
	// the session id is valid.
	activateLayer() {
		this.loginBlueIris();
		super.activateLayer();
		this.timeoutId = setTimeout(() => {
			this.loginBlueIris();
		}, 60000); // 60 seconds
	}

	// When deactivating the layer, 
	// deactivate layer as before, and
	// clear the timer so we stop logging into BlueIris every minute
	deactivateLayer() {
		super.deactivateLayer();
		clearTimeout( this.timeoutId );
	}

	onEachPointFeature(feature, layer) {
		// console.log(feature);
		const stationName = 'name';

		const tooltipContent = feature.properties[stationName] + ' (click for more info)';

		layer.on('click', this['contents'].showImages, this);
		layer.bindTooltip(tooltipContent);
	}

	placeMarkers(feature, latlng) {
		let marker;

		marker = L.icon ({
			iconUrl: 'assets/images/camera.png',
			popupAnchor: [0, -40],
			iconSize: [24, 24]
		});

		return L.marker(latlng, {icon: marker});
		// http://stackoverflow.com/questions/29080194/leaflet-adding-an-offset-to-marker
	}

	// Based on the location of the marker,
	// find all associated camera images.
	showImages(e) {
		console.log(e.latlng);
		// console.log(this['contents']);

		const self = this['contents'];

		let cameraFeatures: any[] = [];
		cameraFeatures = 
			self.value.features.filter((im: any) => {
			return ( 
				im.geometry.coordinates[0] == e.latlng.lng &&
				im.geometry.coordinates[1] == e.latlng.lat );
		});

		// make a copy so original data doesn't get changes
		const cameraFeaturesCopy = JSON.parse(JSON.stringify(cameraFeatures));
		const images:any[] = [];
		for ( let i = 0; i < cameraFeaturesCopy.length; i++ ) {
			const props = cameraFeaturesCopy[i]['properties'];
			console.log(props['image']);
			props['image'] = props?.image + "?session=" + self.sessionID;
			console.log(props['image']);
			console.log(props);
			console.log(self.sessionID);
			images.push( props);
		}

		self.mapService.images = images;
		self.mapService.doDisplayImages(images);
		// console.log(self.mapService.images);

	}


	loginBlueIris() {
		const systemID = this.appConfigService.getConfig()?.SystemID;
		if ( systemID == undefined ) {
		console.log("SystemID not defined in configuration file.")
		return;
		}

		const blueIrisURL = this.appConfigService.getConfig()?.BlueIrisURL;
		if ( blueIrisURL == undefined ) {
		console.log("BlueIrisURL not defined in configuration file.")
		return;
		}

		// get a session id from blue iris
		const formData = { 'cmd': 'login'};
		const httpOptions = {
			headers: new HttpHeaders({ 
					'Content-Type': 'text/plain'
					// 'Connection': 'keep-alive',
					// 'Accept': "*/*"
				})};

		// first, get sessionn id from Blue Iris
		this.http.post(blueIrisURL, formData, httpOptions ).subscribe ({
			next: value => {
				const sessionID = value?.session;

				if ( sessionID == undefined ) {
					console.log("Issues getting Blue Iris session id");
				} else {
					const nsadminwsURL = "blueIris/login";
					const formData = { 
						"system":  systemID,
						"session": sessionID 
					};

					this.adminWS.postService(nsadminwsURL, formData ).subscribe ({
						next: response => {
							if ( response?.blue_iris_status == "success" ) {
								this.activelyLoggedIn = true;
								this.sessionID = response?.session_id;
							}
							console.log(response);
							this.getCameraList();
						}
					})

				}
			},
			error: err => {
				console.log(err);
			}
		})
	}

	getCameraList() {
		const blueIrisURL = this.appConfigService.getConfig()?.BlueIrisURL;
		if ( blueIrisURL == undefined ) {
			console.log("BlueIrisURL not defined in configuration file.")
			return;
		}

		// get a session id from blue iris
		const formData = { 'cmd': 'camlist', 'session': this.sessionID };
		const httpOptions = {
			headers: new HttpHeaders({ 
					'Content-Type': 'text/plain'
				})};

		this.http.post(blueIrisURL, formData, httpOptions ).subscribe ({
			next: value => {
				if ( value.result == "success") {
					const blueIrisGroup = this.appConfigService.getConfig()?.BlueIrisGroup;
					const data = value?.data;
					if ( data != undefined && data.length > 0 ) {
						if ( blueIrisGroup == undefined ) {
							console.log("BlueIrisGroup not defined in configuration file.")
							// print all cameras
							console.log(value[0]);
						} else {
							const filteredData = data.filter ((d: any) => {
								return d?.optionValue == blueIrisGroup;
							})
							console.log("BlueIris data for " + blueIrisGroup + ":", filteredData);
							if ( filteredData.length > 0 ) {
								console.log(filteredData[0]?.group);
							}
						}
					}
				} else {
					console.log("Retrieving a list of cameras failed");
				}
			},
			error: err => {
				console.log(err);
			}
		})


	}
}
